<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form :form="form" slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-item :label="$t('用户keyId  对应用户meter_userinfo表的id')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['userKeyId']" :placeholder="$t('请输入用户keyId  对应用户meter_userinfo表的id')"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('用户编号')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['userId']" :placeholder="$t('请输入用户编号')"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('表编号')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['meterId']" :placeholder="$t('请输入表编号')"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('报表日期')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-date :placeholder="$t('请选择报表日期')" v-decorator="['reportDate']" :trigger-change="true" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('上报所属月份 六位整数 高四位代表年份 低二位代表月份 格式如202010 ')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['reportMonth']" :placeholder="$t('请输入上报所属月份 六位整数 高四位代表年份 低二位代表月份 格式如202010 ')" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('日冻结用量')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['dayUse']" :placeholder="$t('请输入日冻结用量')" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('记录一天用各个时间点的吨数')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['dayUseDetail']" :placeholder="$t('请输入记录一天用各个时间点的吨数')"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('当天上报数据原始二进制字符串')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['meterUpData']" :placeholder="$t('请输入当天上报数据原始二进制字符串')"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('当天上报数据扩展解析字符串')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['meterUpDataDetail']" :placeholder="$t('请输入当天上报数据扩展解析字符串')"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('上期时间 主要针对异常情况或者机械表')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-date :placeholder="$t('请选择上期时间 主要针对异常情况或者机械表')" v-decorator="['preDateTime']" :trigger-change="true" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('上期水表累计流量')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['preMeterSumFlow']" :placeholder="$t('请输入上期水表累计流量')" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('本期抄表时间')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-date :placeholder="$t('请选择本期抄表时间')" v-decorator="['thisDateTime']" :trigger-change="true" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('本期水表累计流量')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['thisMeterSumFlow']" :placeholder="$t('请输入本期水表累计流量')" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('remark')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['remark']" :placeholder="$t('请输入remark')"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('remarkRes1')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['remarkRes1']" :placeholder="$t('请输入remarkRes1')"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('创建日期')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-date :placeholder="$t('请选择创建日期')" v-decorator="['createTime']" :trigger-change="true" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('创建操作员代码')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['createBy']" :placeholder="$t('请输入创建操作员代码')"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('修改时间')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-date :placeholder="$t('请选择修改时间')" v-decorator="['updateTime']" :trigger-change="true" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('修改操作员Id')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['updateBy']" :placeholder="$t('请输入修改操作员Id')"></a-input>
            </a-form-item>
          </a-col>
          <a-col v-if="showFlowSubmitButton" :span="24" style="text-align: center">
            <a-button @click="submitForm">{{ $t('提 交') }}</a-button>
          </a-col>
        </a-row>
      </a-form>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import JFormContainer from '@/components/jeecg/JFormContainer'
  import JDate from '@/components/jeecg/JDate'  

  export default {
    name: 'MeterUserWaterReportDayForm',
    components: {
      JFormContainer,
      JDate,
    },
    props: {
      //流程表单data
      formData: {
        type: Object,
        default: ()=>{},
        required: false
      },
      //表单模式：true流程表单 false普通表单
      formBpm: {
        type: Boolean,
        default: false,
        required: false
      },
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        form: this.$form.createForm(this),
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
        },
        url: {
          add: "/jeecg-charge/meter/meterUserWaterReportDay/add",
          edit: "/jeecg-charge/meter/meterUserWaterReportDay/edit",
          queryById: "/jeecg-charge/meter/meterUserWaterReportDay/queryById"
        }
      }
    },
    computed: {
      formDisabled(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return false
          }
          return true
        }
        return this.disabled
      },
      showFlowSubmitButton(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return true
          }
        }
        return false
      }
    },
    created () {
      //如果是流程中表单，则需要加载流程表单data
      this.showFlowData();
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'userKeyId','userId','meterId','reportDate','reportMonth','dayUse','dayUseDetail','meterUpData','meterUpDataDetail','preDateTime','preMeterSumFlow','thisDateTime','thisMeterSumFlow','remark','remarkRes1','createTime','createBy','updateTime','updateBy'))
        })
      },
      //渲染流程表单数据
      showFlowData(){
        if(this.formBpm === true){
          let params = {id:this.formData.dataId};
          getAction(this.url.queryById,params).then((res)=>{
            if(res.success){
              this.edit(res.result);
            }
          });
        }
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                setTimeout(() => {
                  that.$emit('ok');
                },400)
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }
         
        })
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'userKeyId','userId','meterId','reportDate','reportMonth','dayUse','dayUseDetail','meterUpData','meterUpDataDetail','preDateTime','preMeterSumFlow','thisDateTime','thisMeterSumFlow','remark','remarkRes1','createTime','createBy','updateTime','updateBy'))
      },
    }
  }
</script>